import React from 'react';
import { Outlet, useLocation, useNavigate } from 'react-router-dom';
import AppLayout from '@cloudscape-design/components/app-layout';
import SideNavigation from '@cloudscape-design/components/side-navigation';
import TopNavigation from '@cloudscape-design/components/top-navigation';
import { clearSession, getUser } from '../utils/auth';

export default function PortalLayout() {
  const navigate = useNavigate();
  const location = useLocation();
  const user = getUser();
  const isPlatformAdmin = user?.role === 'platform_admin';
  const items = isPlatformAdmin
    ? [
        { type: 'link', text: 'Mandanten', href: '/admin/mandanten' },
        {
          type: 'expandable-link-group',
          text: 'Anfragen & Aktivitäten',
          href: '/admin/anfragen',
          defaultExpanded: true,
          items: [
            { type: 'link', text: 'Anfrage Monitoring', href: '/admin/anfrage-monitoring' },
          ],
        },
      ]
    : [
        { type: 'link', text: 'Übersicht', href: '/portal' },
        { type: 'link', text: 'Maschinenangebot', href: '/portal/maschinentypen' },
      ];

  return (
    <>
      <div id="portal-topnav">
        <TopNavigation
          identity={{ title: 'SmartRent', href: isPlatformAdmin ? '/admin/mandanten' : '/portal' }}
          utilities={[
            { type: 'button', text: user?.tenantName || user?.email || 'Konto', disabled: true },
            {
              type: 'button',
              text: 'Abmelden',
              onClick: () => {
                clearSession();
                navigate('/login');
              },
            },
          ]}
          onFollow={(event) => {
            event.preventDefault();
            navigate(event.detail.href);
          }}
        />
      </div>
      <AppLayout
        headerSelector="#portal-topnav"
        navigation={(
          <SideNavigation
            activeHref={location.pathname}
            items={items}
            onFollow={(event) => {
              event.preventDefault();
              navigate(event.detail.href);
            }}
          />
        )}
        content={<Outlet />}
        toolsHide
      />
    </>
  );
}
